import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const FormControl = styled(Box)`
  width: 100%;
`

export const Label = styled('label')<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    display: block;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    color: ${theme.colors.gray.dark};
    margin-bottom: 6px;
    opacity: ${disabled ? 0.6 : 1};
  `}
`

export const Textarea = styled('textarea')<{ error?: boolean; disabled?: boolean }>`
  ${({ theme, error, disabled }) => css`
    width: 100%;
    min-height: 96px;
    padding: 12px 14px;
    font-size: 16px;
    font-family: ${theme.fontFamily.openSans}, sans-serif;
    color: ${theme.colors.gray.dark};
    background: ${disabled ? theme.colors.gray.disabled : 'transparent'};
    border: 1px solid;
    border-color: ${error ? theme.colors.error.color : theme.colors.gray.dark};
    border-radius: 8px;
    outline: none;
    resize: vertical;
    box-sizing: border-box;
    transition: border-color 0.2s ease;

    &::placeholder {
      font-size: 16px;
      opacity: 0.4;
    }

    &:hover:not(:disabled) {
      border-color: ${error ? theme.colors.error.color : theme.colors.primary};
    }

    &:focus {
      border: 2px solid ${error ? theme.colors.error.color : theme.colors.primary};
      padding: 11px 13px;
    }

    &:disabled {
      cursor: not-allowed;
      border-color: ${theme.colors.border.disabled};
      color: rgba(92, 92, 92, 0.6) !important;
    }

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.background.hover};
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: ${theme.colors.primary};
    }

    scrollbar-width: thin;
    scrollbar-color: ${theme.colors.background.hover} transparent;
  `}
`

export const ErrorMessage = styled(Box)`
  ${({ theme }) => css`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    padding: 4px 0 0 0;
    color: ${theme.colors.error.color};
  `}
`
